import { render, staticRenderFns } from "./xuanping.vue?vue&type=template&id=a21db48e&"
import script from "./xuanping.vue?vue&type=script&lang=js&"
export * from "./xuanping.vue?vue&type=script&lang=js&"
import style0 from "./xuanping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports